export function StudioAwards(award) {
	const awardIcons = [
			{id: 6, slug: 'staff-pick', icon: 'fas fa-crown', intro: ``, content: 'Staff Pick'}
		,	{id: 5, slug: 'staff-pick', icon: 'fas fa-crown', intro: `This week's`, content: 'Staff Pick'}
		,	{id: 4, slug: 'prev-staff-pick', icon: 'fas fa-crown', intro: 'Previously a', content: 'Staff Pick'}
		,	{id: 3, slug: 'adp-finalist', icon: 'fas fa-trophy-alt', intro: 'AFOL Designer Program', content: 'Finalist'}
		,	{id: 2, slug: 'adp-semi', icon: 'fas fa-trophy', intro: 'AFOL Designer Program', content: 'Semi-finalist'}
		,	{id: 1, slug: 'adp-mention', icon: 'fas fa-trophy', intro: 'AFOL Designer Program', content: 'Honorable Mention'}
	];

	return awardIcons.filter(icon => icon.id == award)[0];
}